import React, { useEffect } from 'react'
import Footer from '../core/Footer';
import { Navbar } from '../core/Navbar';
import { useLayoutEffect } from 'react';
import { Content } from '../sections/service/Content';

export const Service = () => {
    useLayoutEffect(()=>{
        window.scrollTo(0,0)
    });

    useEffect(() => {
        document.title = "Services - High1Digital Consulting Pvt. Ltd."
    }, []);

    return (
        <div>
            <Navbar />
            <Content/>
            <Footer />
        </div>
    )
}
